import { GetJobsResponse } from '../../job_search/types';
import { jobSearchPath } from '../../utilities/api_relative_paths';
import { checkStatus } from '../../utilities/fetch';
import { createQueryString } from '../../utilities/utilities';
import pickBy from 'lodash/pickBy';

const getCommunityJobs = (query: string): Promise<GetJobsResponse> => {
  const filterParams = {
    job_types: ['community jobs'],
    keywords: query && query?.trim().length > 0 ? [query] : null,
  };

  return fetch(
    jobSearchPath +
      createQueryString({
        filter: pickBy(filterParams),
        page: { size: 3 },
      })
  )
    .then(checkStatus)
    .then((response) => response.json())
    .catch((error) => Promise.reject(error));
};

export { getCommunityJobs };
